import { SubscriptionActions } from 'store/actions/subscription';
import { mapTopups } from 'helpers/subscriptionHelpers';
import moment from 'moment';

function getSolutionsSkuFromCart(cart) {
  const lensWithSolutionDetails = [cart.left, cart.right, cart.extras && cart.extras.solution]
    .find((lens) => lens && lens.solution_detail);
  return lensWithSolutionDetails
    ? {
      sku: lensWithSolutionDetails.solution_detail.solution_sku,
      description: lensWithSolutionDetails.solution_detail.solution_supplier_name,
    } : null;
}

const DEFAULT_SUBSCRIPTIONS_MAP = {
  activeSubs: [],
  topUps: [],
  currentSubscriptionIndex: null,
};

function reduceSubscriptionList(subscriptionsList) {
  const subscriptionsMap = subscriptionsList.reduce(
    (accumulator, s) => {
      if (
        ['Active', 'Pending'].includes(s.status)
        && s.order_type === 'Normal'
      ) {
        if (accumulator.currentSubscriptionIndex === null) {
          accumulator.currentSubscriptionIndex = 0;
        }
        accumulator.activeSubs.push(s);
      } else if (s.order_type === 'Top-up') {
        const topup = mapTopups(s);
        accumulator.topUps.push(topup);

        if (
          moment(topup.topupDate)
            .add(3, 'months')
            .isAfter()
        ) {
          accumulator.toppedUpAmountWithinThreeMonths
            += topup.topupSize.boxSize * topup.topupSize.quantity;
        }
      }
      return accumulator;
    },
    {
      activeSubs: [],
      topUps: [],
      currentSubscriptionIndex: null,
      toppedUpAmountWithinThreeMonths: 0,
    },
  );
  if (!subscriptionsMap.activeSubs.length) {
    throw new Error('Could not find an active or pending subscription');
  }

  return subscriptionsMap;
}

export default {
  subscriptionLoadFailed: (state = false, action) => {
    const loadFailedState = {
      [SubscriptionActions.SET_SUBSCRIPTION_LOAD_FAILED]: () => true,
      [SubscriptionActions.RESET]: () => false,
    };
    if (loadFailedState[action.type]) {
      return loadFailedState[action.type]();
    }
    return state;
  },
  subscriptionsList: (state = DEFAULT_SUBSCRIPTIONS_MAP, action) => {
    const stateMap = {
      [SubscriptionActions.SET_SUBSCRIPTIONS_LIST]: () => reduceSubscriptionList(action.payload),
      [SubscriptionActions.RESET_SUBSCRIPTIONS_LIST]: () => ({ ...state }),
      [SubscriptionActions.SET_CURRENT_SUBSCRIPTION_INDEX]: () => ({
        ...state,
        currentSubscriptionIndex: action.payload,
      }),
      [SubscriptionActions.RESET]: () => DEFAULT_SUBSCRIPTIONS_MAP,
    };
    if (stateMap[action.type]) {
      return stateMap[action.type]();
    }
    return state;
  },

  subscription: (state = null, action) => {
    const stateMap = {
      [SubscriptionActions.SET_SUBSCRIPTION]: () => ({
        ...action.payload,
        recommendedSolution: getSolutionsSkuFromCart(action.payload.cart),
      }),
      [SubscriptionActions.RESET]: () => null,
    };
    if (stateMap[action.type]) {
      return stateMap[action.type]();
    }
    return state;
  },

  subscriptions: (state = [], action) => {
    const stateMap = {
      [SubscriptionActions.SET_SUBSCRIPTIONS]: () => action.payload
        && action.payload.map((sub) => ({
          ...sub,
          isNonLensMail: !sub.packs.find((p) => p.non_lens_mail_order === 'No'),
          packs: sub.packs.map((p, index) => ({
            ...p,
            previousPack: sub.packs[index - 1],
            nextPack: sub.packs[index + 1],
          })),
        })),
      [SubscriptionActions.RESET_SUBSCRIPTIONS_LIST]: () => [],
      [SubscriptionActions.RESET]: () => [],
    };
    if (stateMap[action.type]) {
      return stateMap[action.type]();
    }
    return state;
  },

  store: (state = null, action) => {
    const stateMap = {
      [SubscriptionActions.SET_STORE]: () => action.payload,
      [SubscriptionActions.RESET]: () => null,
    };
    if (stateMap[action.type]) {
      return stateMap[action.type]();
    }
    return state;
  },
};
